import React from 'react';
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  Grid,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Typography,
  makeStyles,
} from '@material-ui/core';
import HorizontalMultiSelect from '../common/search/HorizontalMultiSelect';
import PopupMultiDropDown from '../common/PopupMultiDropDown';
import Theme from '../ui/Theme';

const useStyles = makeStyles(() => ({
  cardContent: {
    height: '85px',
    marginTop: '10px',
    marginBottom: '10px',
    borderRadius: '8px',
    overflow: 'visible',
    padding: '0px 10px',
    display: 'flex',
    flexDirection: 'column',
  },
  reset: {
    fontWeight: '500',
    fontSize: '13px',
    color: 'white',
    cursor: 'pointer',
    height: '40px',
    width: '90%',
  },
  filterBy: {
    color: 'rgba(102, 112, 133, 1)',
    fontWeight: '600',
    fontSize: '12px',
    marginTop: '5px',
  },
  textfield: {
    backgroundColor: Theme.palette.secondary.main,
    height: '40px',
    width: '100%',
    padding: '12px 12px 12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
  },
  label: {
    fontSize: '12px',
    marginBottom: '2px',
  },
  BtnWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '18px',
    width: '250px',
  },
}));

export default function PXFilterBar({
  appliedFilters,
  pxDashboardFilters,
  handleFilterChange,
  handleClearFilters,
  handleApplyFilter,
  isButtonDisabled,
  PERIOD_ARR,
  dateRange,
  handleAllSourcesToggle,
  handleAllPipelineStatus,
  setAppliedFilters,
  DEFAULT_FILTERS,
}) {
  const classes = useStyles();

  return (
    <Grid item>
      <Card className={classes.cardContent}>
        <CardContent
          style={{
            width: '100%',
          }}
        >
          <Grid container direction="row" alignItems="center" justifyContent="space-between">
            <Grid item>
              <Typography className={classes.filterBy}>Filter By:</Typography>
            </Grid>

            <Grid item xs={2}>
              <FormControl>
                <InputLabel htmlFor="source-select">Source: </InputLabel>
                <Select
                  style={{ height: '40px' }}
                  value={appliedFilters.source}
                  onChange={(e) => {
                    const selectedSource = e.target.value;
                    const len = selectedSource.length;

                    if (selectedSource[len - 1] !== 'all') {
                      handleFilterChange('source', selectedSource);
                    } else if (appliedFilters.source.length === pxDashboardFilters?.source?.length) {
                      handleAllSourcesToggle(false);
                    } else {
                      handleAllSourcesToggle(true);
                    }
                  }}
                  input={<Input disableUnderline className={classes.textfield} />}
                  displayEmpty
                  renderValue={(value) => {
                    if (value.length && Array.isArray(value)) {
                      return value.length === pxDashboardFilters?.source?.length ? 'All' : `${value.join(', ')}`;
                    }
                    return 'Source';
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 48 * 4.5 + 8,
                        width: 250,
                      },
                    },
                  }}
                  multiple
                >
                  <MenuItem key="all" name="all" value="all">
                    <Checkbox
                      color="primary"
                      checked={appliedFilters?.source?.length === pxDashboardFilters?.source?.length}
                      onChange={(e) => handleAllSourcesToggle(e.target.checked)}
                    />
                    <ListItemText primary="All" />
                  </MenuItem>
                  {pxDashboardFilters?.source?.map((s) => (
                    <MenuItem key={s.source} name={s.source} value={s.source}>
                      <Checkbox color="primary" checked={appliedFilters.source.some((i) => i === s.source)} />
                      <ListItemText primary={s.source} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item style={{ width: '100%' }} xs={2}>
              <InputLabel className={classes.label} htmlFor="select-dealership">
                Dealerships:
              </InputLabel>
              <HorizontalMultiSelect
                list={pxDashboardFilters?.dealerships || []}
                selectedList={appliedFilters.dealerships}
                searchPlaceholder="Search Dealerships"
                setSelectedList={(value) => handleFilterChange('dealerships', value)}
                inputWidth="100%"
                popoverWidth="17vw"
                placeholderButtonLabel="Select Dealerships"
                inputBackgroudColor
              />
            </Grid>

            <Grid item xs={2}>
              <InputLabel className={classes.label} htmlFor="salesPipelineStatust">
                Sales Pipeline Status:
              </InputLabel>
              <PopupMultiDropDown
                allowSelectAll
                list={pxDashboardFilters?.salesPipelineStatus || []}
                height="40px"
                width="100%"
                name="salesPipelineStatus"
                handleChange={(e) => {
                  const selectedItems = e.target.value;
                  const len = selectedItems?.length;
                  if (selectedItems[len - 1] !== 'all') {
                    const salesPipelineStatus = selectedItems.map((val) => {
                      const arr = pxDashboardFilters?.salesPipelineStatus?.filter((item) => item.title === val);
                      return arr[0];
                    });
                    handleFilterChange('salesPipelineStatus', salesPipelineStatus);
                  } else if (
                    appliedFilters.salesPipelineStatus.length === pxDashboardFilters?.salesPipelineStatus?.length
                  ) {
                    setAppliedFilters((app) => ({
                      ...app,
                      salesPipelineStatus: DEFAULT_FILTERS.salesPipelineStatus,
                    }));
                  } else {
                    setAppliedFilters((app) => ({
                      ...app,
                      salesPipelineStatus: pxDashboardFilters?.salesPipelineStatus?.map((item) => item),
                    }));
                  }
                }}
                value={appliedFilters.salesPipelineStatus.map((i) => i?.title)}
                mainArr={appliedFilters.salesPipelineStatus}
                filter={pxDashboardFilters?.salesPipelineStatus || []}
                handleAllPipelineStatus={handleAllPipelineStatus}
                showMargin={false}
              />
            </Grid>

            <Grid item xs={2}>
              <FormControl>
                <InputLabel htmlFor="time-period">Time period:</InputLabel>
                <Select
                  value={appliedFilters.timePeriod}
                  input={<Input disableUnderline className={classes.textfield} />}
                  displayEmpty
                  renderValue={(value) =>
                    dateRange ? `${dateRange.startDate} - ${dateRange.endDate}` : PERIOD_ARR[value]
                  }
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 48 * 4.5 + 8,
                        width: 250,
                      },
                    },
                  }}
                >
                  {PERIOD_ARR.map((s, key) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <MenuItem value={key} key={key} onClick={() => handleFilterChange('time', key)}>
                      {s}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid className={classes.BtnWrapper}>
              <Grid item style={{ width: '50%' }}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.reset}
                  onClick={handleApplyFilter}
                  disabled={isButtonDisabled}
                >
                  Apply
                </Button>
              </Grid>
              <Grid item style={{ width: '50%' }}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.reset}
                  onClick={() => handleClearFilters(true)}
                  disabled={isButtonDisabled}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}
